import { c as _c } from "react/compiler-runtime";
import { Modal } from '@systemeio/ui';
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration';
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration';
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton';
import { useGoogleIntegrations } from 'modules/profile/integrations/google/hooks/use-google-integrations';
import { IntegrationUseCaseEnum } from 'modules/profile/integrations/google/types';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { GoogleMeetIcon } from '@systemeio/ui/icons';
export const GoogleMeetIntegrationComingSoon = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GoogleMeetIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.user_settings.integrations_page.google_meet.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.user_settings.integrations_page.google_meet.subtitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <WrapperIntegration icon={t0} title={t1} subTitle={t2} isComingSoon={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const GoogleMeetIntegration = t0 => {
  const $ = _c(34);
  const {
    onManageCalendar
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const {
    getIntegrationsByUseCase
  } = useGoogleIntegrations();
  let data;
  let handleManageCalendar;
  let t1;
  if ($[0] !== getIntegrationsByUseCase || $[1] !== onManageCalendar) {
    data = getIntegrationsByUseCase(IntegrationUseCaseEnum.Calendar);
    let t2;
    if ($[5] !== onManageCalendar) {
      t2 = async function handleManageCalendar() {
        setOpened(false);
        onManageCalendar();
      };
      $[5] = onManageCalendar;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    handleManageCalendar = t2;
    t1 = data?.items.some(_temp) ?? false;
    $[0] = getIntegrationsByUseCase;
    $[1] = onManageCalendar;
    $[2] = data;
    $[3] = handleManageCalendar;
    $[4] = t1;
  } else {
    data = $[2];
    handleManageCalendar = $[3];
    t1 = $[4];
  }
  const isConnected = t1;
  if (!data) {
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <WrapperIntegrationSkeleton />;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GoogleMeetIcon />;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t) {
    t3 = t("dashboard.user_settings.integrations_page.google_meet.name");
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t("dashboard.user_settings.integrations_page.google_meet.subtitle");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(true);
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isConnected || $[15] !== t3 || $[16] !== t4) {
    t6 = <WrapperIntegration icon={t2} title={t3} subTitle={t4} onClick={t5} isConnect={isConnected} />;
    $[14] = isConnected;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t) {
    t7 = t("dashboard.user_settings.integrations_page.google_meet.title");
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(false);
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = isConnected ? "dashboard.user_settings.integrations_page.google_meet_integration.help_connected-2" : "dashboard.user_settings.integrations_page.google_meet_integration.help_not_connected-2";
  let t10;
  if ($[21] !== t) {
    t10 = t("dashboard.user_settings.integrations_page.google_meet_integration.manage_calendar_integration");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== handleManageCalendar || $[24] !== t10 || $[25] !== t9) {
    t11 = <ConnectInfoIntegration handleOpenIntegrationLogin={handleManageCalendar} infoText={t9} buttonTitle={t10} />;
    $[23] = handleManageCalendar;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== opened || $[28] !== t11 || $[29] !== t7) {
    t12 = <Modal title={t7} onClose={t8} opened={opened}>{t11}</Modal>;
    $[27] = opened;
    $[28] = t11;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t6) {
    t13 = <>{t6}{t12}</>;
    $[31] = t12;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
function _temp(integration) {
  return !integration.disconnectedAt;
}